export const subscriptionStatusLabel = (status: string | null): string => {
  switch (status) {
    case 'active':
      return 'Ativo';
    case 'trial':
      return 'Em teste';
    case 'past_due':
      return 'Atrasado';
    case 'canceled':
      return 'Cancelado';
    default:
      return 'Sem plano';
  }
};
